<div class="row-with-icon d-flex justify-content-between align-items-center">
    <div class="truncate line-height-18px text-{{ ticket.source | ticketSourceEnglish }}">
        @if (isStatusAvailable) {
            @switch (ticket.status) {
                @case (ticketStatusEnum.open) {
                    <sb-inline-svg
                        class="icon icon-status icon-{{ ticket.source | ticketSourceEnglish }} icon-left"
                        tooltip="{{ 'Open' | translate }}"
                        placement="bottom"
                        container="body"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Open ticket icon.svg'">
                    </sb-inline-svg>
                }
                @case (ticketStatusEnum.pending) {
                    <sb-inline-svg
                        class="icon icon-status icon-{{ ticket.source | ticketSourceEnglish }} icon-left"
                        tooltip="{{ 'Pending' | translate }}"
                        placement="bottom"
                        container="body"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pending ticket icon.svg'">
                    </sb-inline-svg>
                }
                @case (ticketStatusEnum.completed) {
                    <sb-inline-svg
                        class="icon icon-status icon-{{ ticket.source | ticketSourceEnglish }} icon-left"
                        tooltip="{{ 'Closed' | translate }}"
                        placement="bottom"
                        container="body"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Completed ticket icon.svg'">
                    </sb-inline-svg>
                }
            }
        } @else {
            <span
                class="icon icon-status icon-{{ ticket.source | ticketSourceEnglish }} social-icon-{{
                    ticket.source | ticketSourceEnglish
                }} icon-left"
                [ngClass]="{ messenger: ticket.detailedSource === detailedTicketSourceEnum.facebookPrivateMessage }">
            </span>
        }

        <small
            class="truncate"
            [ngClass]="{ messenger: ticket.detailedSource === detailedTicketSourceEnum.facebookPrivateMessage }">
            {{ ticket.detailedSource | detailedTicketSource: ticket.isAdTicket }}
            @if (ticket.sourceName) {
                <span style="font-size: 9px">▶&nbsp;</span>
                {{ ticket.sourceName }}
            }
            @if (ticket.replyCount) {
                ({{ ticket.replyCount }})
            }
        </small>
        @if (commonDataService.customerSettings.handleSettings.isEnabled && ticket.unhandledRepliesCount) {
            <span class="badge badge-unhandled ms-1" tooltip="{{ 'Unhandled replies' | translate }}" container="body">{{
                ticket.unhandledRepliesCount
            }}</span>
        }
    </div>

    <span class="d-flex justify-content-between align-items-center ms-1">
        @if (ticket.hasSurvey) {
            <sb-inline-svg
                class="me-1 icon star-icon"
                [url]="'./sb-tools/theme/images/Svg icons WEB/Settings icons/Star icon - active.svg'">
            </sb-inline-svg>
        }
        @if (ticket.forwardedTo?.length) {
            <sb-inline-svg
                class="me-1 icon icon-forward"
                tooltip="{{ 'Forwarded to: ' | translate }} {{ ticket.forwardedTo.join(', ') }}"
                aria-label="My icon"
                placement="bottom"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Wide arrow.svg'"
                container="body">
            </sb-inline-svg>
        }
        @if (ticket.isAssigned) {
            <sb-inline-svg
                class="me-1 icon icon-locked"
                tooltip="{{ 'Assigned to' | translate }} {{ ticket.assignee.name }}"
                aria-label="My icon"
                placement="bottom"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Lockd icon.svg'"
                container="body">
            </sb-inline-svg>
        }
        @if (ticket.isMuted) {
            <sb-inline-svg
                class="icon me-1"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Muted icon.svg'">
            </sb-inline-svg>
        }
        @if (ticket.noteCount) {
            <span class="note-bubble-icon me-1">{{ ticket.noteCount }}</span>
        }

        <small
            class="text-light"
            tooltip="{{ ticket.lastThreadElementCreationTime | date: 'dd.MM.yyyy HH:mm' }}"
            placement="bottom"
            container="body">
            {{ ticket.lastThreadElementCreationTime | ticketTime }}
        </small>
    </span>
</div>

<div class="row-with-icon d-flex align-items-center justify-content-between">
    <div class="truncate" [ngClass]="{ 'min-height-21px': ticket.hasAttachments }">
        @if (ticket.hasAttachments) {
            <sb-inline-svg
                class="icon icon-left top-50"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
            </sb-inline-svg>
        }

        <span class="truncate">
            {{ ticket.firstMessageCreator.name || ticket.firstMessageCreator.email }}
        </span>
    </div>

    @if (ticket.importance === importanceEnum.high) {
        <sb-inline-svg
            class="icon icon-pri icon-pri-high"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v2.svg'">
        </sb-inline-svg>
    } @else if (ticket.importance === importanceEnum.low) {
        <sb-inline-svg
            class="icon icon-pri icon-pri-low"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Priority icon down.svg'">
        </sb-inline-svg>
    }
</div>

<div class="truncate" [innerHTML]="ticket.title | replaceEmojis: false : true"></div>

@if (commonDataService.customerSettings.isSessionAuthenticationEnabled && ticket.sessionAuthentication) {
    @let authenticationLevel = ticket.sessionAuthentication.level;
    <span
        class="authentication-level-badge authentication-level-{{ authenticationLevel }} mt-1"
        data-testid="inbox-ui-ticket-list-authentication-level">
        {{ 'Authentication level' | translate }}: {{ authenticationLevel }}
    </span>
}

@if (!isFeedViewMinimized) {
    <div class="d-flex justify-content-between align-items-center">
        @if (ticket.lastReplyMessage) {
            <div
                class="text-light truncate"
                [innerHTML]="ticket.lastReplyMessage.text | replaceEmojis: false : true"></div>
        } @else {
            <div class="text-light truncate" [innerHTML]="ticket.message.text | replaceEmojis: false : true"></div>
        }

        @if (ticket.lastReplyByTeamAuthor) {
            <div class="d-flex flex-row align-items-center">
                <sb-inline-svg
                    class="icon icon-flipped"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Forward icon.svg'">
                </sb-inline-svg>
                &nbsp;
                <sb-user-avatar
                    class="user-avatar-xxs"
                    [user]="ticket.lastReplyByTeamAuthor"
                    [size]="'extra-extra-small'"
                    [isNeedTooltip]="true">
                </sb-user-avatar>
            </div>
        }
    </div>
}

@if (ticket.category && !isFeedViewMinimized) {
    <span
        class="label label-sm truncate"
        container="body"
        placement="auto"
        tooltip="{{ 'Category' | translate }}: {{ ticket.category | categoryFullName }}">
        {{ ticket.category.label }}
    </span>
}
